import { Alarms } from "./Alarms";
export default Alarms;
